export default "__VITE_ASSET__iGzpqX_D__"